import { render, staticRenderFns } from "./EditorContent.vue?vue&type=template&id=fc2f5aea&scoped=true&"
import script from "./EditorContent.vue?vue&type=script&lang=js&"
export * from "./EditorContent.vue?vue&type=script&lang=js&"
import style0 from "./EditorContent.vue?vue&type=style&index=0&id=fc2f5aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2f5aea",
  null
  
)

export default component.exports